<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-sas-clinic-login></app-sas-clinic-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-sas-clinic-register></app-sas-clinic-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-sas-clinic-forgot-password></app-sas-clinic-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-sas-clinic-change-password-sent></app-sas-clinic-change-password-sent>
  </div>

  <app-sas-clinic-register-resend
    *ngIf="page === 'register-resend'"
  ></app-sas-clinic-register-resend>
</ng-container>
